<template>
  <div class="listContainer">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>工单管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a>下载</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end-->
    <!-- content -->
    <section>
      <h2>
        一、下载工单
        <a>【默认下载全部】</a>
      </h2>
      <ul>
        <li>
          <h3>1、每日数据登记</h3>
          <div>
            <span>
              <label>项目名称：</label>
              <a-select style="width:200px" mode="multiple">
                <a-select-option
                  v-for="(item, i) in proList"
                  :key="i"
                  :value="item.id"
                  >{{ item.project_name }}</a-select-option
                >
              </a-select>
            </span>
            <span>
              <label>日期：</label>
              <a-range-picker />
            </span>
            <span>
              <a-button type="primary">下载</a-button>
            </span>
          </div>
        </li>
      </ul>
    </section>
    <!-- content end -->
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      proList: []
    };
  },
  mounted() {
    this.getBusiness(); //获取项目列表
  },
  methods: {
    excelData(e) {
      this.attence = e.target.files[0].name;
      this.attenceFile = e.target.files[0];
    },
    getBusiness() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.logistics +
        "Driver/queryManagerProjectList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListJd = [];
            this.proListHl = [];
            res.data.data.project_list.forEach(element => {
              if (element.type == 3) {
                this.proListJd.push({
                  id: element.id,
                  project_name: element.project_name
                });
              } else if (element.type == 2) {
                this.proListHl.push({
                  id: element.id,
                  project_name: element.project_name
                });
              }
            });
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  //   padding: 30px 4%;
  > section {
    margin-bottom: 50px;
    padding: 0 4%;
    > div {
      margin: 20px 0 30px;
      > label {
        display: inline-block;
        margin-right: 10px;
      }
    }
    h2 {
      font-size: 14px;
      font-weight: normal;
      margin-top: 30px;
      margin-bottom: 10px;
      a {
        font-size: 14px;
        display: inline-block;
        color: #999;
      }
    }
    h3 {
      margin-bottom: 10px;
    }
    input {
      margin: 20px 30px;
    }
    button {
      display: block;
      margin: 0 30px;
    }
    ul > li {
      margin: 10px 3%;
      margin-bottom: 20px;
      > div {
        display: flex;
        flex-direction: row;
        > span {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-right: 20px;
        }
      }
    }
  }
}
</style>
